export const LOCALES = {
  br: "pt-BR",
  mx: "es-MX"
}

export const BRAVO_SITE_URLS = {
  "pt-BR": process.env.REACT_APP_BRAVO_BR_SITE_URL,
  "es-MX": process.env.REACT_APP_BRAVO_MX_SITE_URL
}

export const COUNTRIES_BY_LOCALE = {
  "pt-BR": "br",
  "es-MX": "mx"
}

export const MEETING_STATUSES = {
  NONE: "NONE",
  STARTED: "MEETING_STARTED",
  LEFT: "MEETING_LEFT",
  INVALID: "INVALID_MEETING",
  VALID: "VALID_MEETING"
}

export const AUDIO_URLS = {
  CRITICAL_ERROR: "https://static.videosdk.live/prebuilt/notification_critical_err.mp3",
  ERROR: "https://static.videosdk.live/prebuilt/notification_err.mp3",
  NOTIFICATION: "https://static.videosdk.live/prebuilt/notification.mp3",
}
